export default __webpack_public_path__ + "static/media/first-right.6abc4e63.png";